<template>
    <section class="break">
        <Overlay :image="picture"/>
    </section>
</template>
<script>
export default {
    name: 'BriefBreak',
    props: {
        picture: {
            type: String,
            required: true,
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

section {
    position: relative;
    height: 250px;
    z-index: 0;
}
</style>
